export const longDateOptions: Intl.DateTimeFormatOptions = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };

export function standardDate(date: Date): StandardDate {
    let dateString:StandardDate = "0000-00-00";
    let month: number = date.getMonth() + 1;
    let day: number = date.getDate();
    if (month < 10) { month = Number("0" + month); }
    if (day < 10) { day = Number("0" + day); }
    dateString = date.getFullYear() + "-" + month + "-" + day;
    return dateString as StandardDate;
}

export function parseStandardDate(dts: StandardDate): Date {
    let parts = dts.split("-");
    return new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]));
}

export function getSundaysBetween(startDate: Date, endDate: Date): Date[] {
    const sundays: Date[] = [];
    const currentDate = new Date(startDate);
    if (startDate > endDate) {
        return sundays; // Return empty array if start date is after end date
    }
    // Ensure the start date is a Sunday
    currentDate.setDate(currentDate.getDate() + (7 - currentDate.getDay()) % 7);

    while (currentDate <= endDate) {
        sundays.push(new Date(currentDate)); // Add the Sunday to the list
        currentDate.setDate(currentDate.getDate() + 7); // Move to the next Sunday
    }

    return sundays;
}


export function webpName(fileName: string): string {
    const parts = fileName.split('.');
    if (parts.length < 2) return fileName; // No extension found
    parts[parts.length - 1] = 'webp'; // Change the extension to webp
    return parts.join('.');
}
